module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('blockquote', [_c('p', [_vm._v(_vm._s(_vm.test.content))]), _vm._v(" "), _c('cite', [_vm._v(_vm._s(_vm.test.author)), _c('b', [_vm._v(", " + _vm._s(_vm.test.type))])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h5', [_vm._v("Testimonial")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b7537d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/testimonial.vue
// module id = 485
// module chunks = 1